import { render } from "./index-banner.vue?vue&type=template&id=5d344a84&scoped=true"
import script from "./index-banner.vue?vue&type=script&lang=js"
export * from "./index-banner.vue?vue&type=script&lang=js"

import "./index-banner.vue?vue&type=style&index=0&id=5d344a84&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d344a84"]])

export default __exports__